import React from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import Login from './containers/Login/Login';
import Unauthorized from './containers/Unauthorized/Unauthorized';
import ChangePassword from './containers/ChangePassword/ChangePassword';
import ObservationEvents from './containers/EventDetails/ObservationEvents';
import SingleEvent from './containers/EventDetails/SingleEvent';
import Safety from './containers/Safety/Safety';
import Events from './containers/Events/Events';
import DriverPerformance from './containers/DriverPerformance/DriverPerformance';
import NotFoundError from './containers/NotFoundError/NotFoundError';
import history from './history';
import { observer, inject } from 'mobx-react';
import { logPageView } from './apis/GoogleAnalyticsApi';
import URI from 'urijs';
import Verify from './containers/Verify/Verify';
import { OIDCMain } from './containers/OIDC/OIDCMain';
import { OidcProvider } from '@axa-fr/react-oidc';
import { LoadingScreen } from './containers/LoadingScreen/LoadingScreen';
import { OIDCLoading } from './containers/OIDC/OIDCLoading';
import { OIDCError } from './containers/OIDC/OIDCError';
import AppError from './containers/AppError/AppError';
@inject('ConfigStore')
@inject('AuthStore')
@inject('GoogleAnalyticsStore')
@inject('AuthZStore')
@observer
class MainRoutes extends React.Component {
  oidcConfig = {};

  constructor(props) {
    super(props);
    this.setOidcConfig(props);
    this.startListeningToHistoryChanges();
  }

  setOidcConfig(props) {
    const { config, configurationKeys } = props.ConfigStore;
    this.oidcConfig = {
      client_id: config[configurationKeys.oidcClientId],
      scope: config[configurationKeys.oidcScope],
      redirect_uri: config[configurationKeys.oidcRedirectUri],
      silent_redirect_uri: config[configurationKeys.oidcSilentRedirectUri],
      authority: config[configurationKeys.oidcAuthority],
      authority_configuration: {
        authorization_endpoint: config[configurationKeys.oidcAuthEndpoint],
        token_endpoint: config[configurationKeys.oidcTokenEndpoint],
        userinfo_endpoint: config[configurationKeys.oidcUserInfoEndpoint],
        end_session_endpoint: config[configurationKeys.oidcEndSessionEndpoint],
        revocation_endpoint: config[configurationKeys.oidcRevocationEndpoint],
        issuer: config[configurationKeys.oidcIssuer]
      },
      refresh_time_before_tokens_expiration_in_second:
        config[configurationKeys.oidcExpiresAt] -
        config[configurationKeys.oidcRefreshTimeInSec],
      storage: localStorage
    };
  }

  startListeningToHistoryChanges() {
    history.listen(location => {
      if (this.props.GoogleAnalyticsStore.isInitialized) {
        const page = this.props.page || location.pathname;
        logPageView(page);
      }
    });
  }

  handleAuth0Authentication = (nextState, replace) => {
    if (/access_token|id_token|error/.test(nextState.location.hash)) {
      if (/state/.test(nextState.location.hash)) {
        this.props.AuthStore.handleAuth0Authentication();
      } else {
        //If IDP login scenario
        this.props.AuthStore.renewToken();
      }
    }
  };

  /**
   * Sends the search query string authToken and idToken to the auth store for processing.
   */
  handleTokenQueryAuthentication(nextState) {
    const parsedSearch = URI.parseQuery(nextState.location.search);
    this.props.AuthStore.loginInfo['appLauncher'] = false;
    this.props.AuthStore.handleTokenAuthentication(
      parsedSearch.accessToken,
      parsedSearch.idToken
    );
  }

  handleGP2Authentication(nextState) {
    const parsedSearch = URI.parseQuery(nextState.location.search);
    this.props.AuthStore.loginInfo['appLauncher'] = false;
    this.props.AuthStore.handleGP2Authentication(
      parsedSearch.accessToken,
      parsedSearch.idToken
    );
  }

  handleAppLAuthentication() {
    this.props.AuthStore.loginInfo['appLauncher'] = true;
    this.props.AuthStore.handleAppLAuthentication();
  }

  handleGP2Logout() {
    this.props.AuthStore.removeStorageForLogout();
  }

  isLegacyAppRedirect = nextState => {
    return /legacy_redirect/.test(nextState.location.search);
  };

  isSsoUser = nextState => {
    return /sso/.test(nextState.location.search);
  };

  getObservationNameFromPath = props => {
    return decodeURIComponent(props.match.params.observationName.trim());
  };

  getEventNumberFromPath = props => {
    return (
      decodeURIComponent(props.match.params.eventNumber) || ''
    ).toUpperCase();
  };

  render() {
    return (
      <OidcProvider
        configuration={this.oidcConfig}
        callbackSuccessComponent={OIDCLoading}
        authenticatingComponent={OIDCLoading}
        loadingComponent={OIDCLoading}
        serviceWorkerNotSupportedComponent={OIDCError}
        authenticatingErrorComponent={OIDCError}
        sessionLostComponent={OIDCError}
      >
        <Router history={history}>
          <div>
            <Switch>
              <Route
                exact
                path="/"
                render={props => {
                  return (
                    <Verify
                      {...props}
                      isLegacyAppRedirect={this.isLegacyAppRedirect(props)}
                    />
                  );
                }}
              />
              <Route
                path="/login"
                render={props => {
                  return (
                    <Login
                      {...props}
                      isLegacyAppRedirect={this.isLegacyAppRedirect(props)}
                    />
                  );
                }}
              />
              <Route
                path="/verify"
                render={props => {
                  return (
                    <Verify
                      {...props}
                      isLegacyAppRedirect={this.isLegacyAppRedirect(props)}
                    />
                  );
                }}
              />
              <Route
                path="/connect"
                render={props => {
                  this.handleAppLAuthentication();
                  return <LoadingScreen {...props} />;
                }}
              />
              <Route path="/changepassword" component={ChangePassword} />
              <Route
                path="/callback"
                render={props => {
                  this.handleAuth0Authentication(props);
                  return <LoadingScreen {...props} />;
                }}
              />
              <Route
                path="/with-token"
                render={props => {
                  this.handleTokenQueryAuthentication(props);
                  return <LoadingScreen {...props} />;
                }}
              />
              <Route
                path="/with-gp2token"
                render={props => {
                  this.handleGP2Authentication(props);
                  return <LoadingScreen {...props} />;
                }}
              />
              <Route
                path="/gp2-logout"
                render={props => {
                  this.handleGP2Logout();
                  return <LoadingScreen {...props} />;
                }}
              />
              <Route
                path="/unauthorized"
                render={props => {
                  return (
                    <Unauthorized
                      {...props}
                      isSsoUser={this.isSsoUser(props)}
                    />
                  );
                }}
              />
              <Route path="/safety" component={Safety} />
              <Route path="/safetysecure" component={OIDCMain} />
              <Route path="/authentication" component={OIDCMain} />
              <Route path="/drivingperformance" component={DriverPerformance} />
              <Route
                exact
                path="/observation/:observationName"
                render={props => {
                  return (
                    <Events
                      observationName={this.getObservationNameFromPath(props)}
                    />
                  );
                }}
              />
              <Route
                exact
                path="/observation/:observationName/event/:eventNumber"
                render={props => {
                  return (
                    <ObservationEvents
                      observationName={this.getObservationNameFromPath(props)}
                      eventNumber={this.getEventNumberFromPath(props)}
                    />
                  );
                }}
              />
              <Route
                exact
                path="/eventSearch/:eventNumber"
                render={props => {
                  return (
                    <SingleEvent
                      {...props}
                      eventNumber={this.getEventNumberFromPath(props)}
                    />
                  );
                }}
              />
              <Route path="/error" component={AppError} />
              <Route path="*" component={NotFoundError} />
            </Switch>
          </div>
        </Router>
      </OidcProvider>
    );
  }
}

export { MainRoutes };



// WEBPACK FOOTER //
// ./src/routes.js